import LanguageIcon from '@mui/icons-material/Language';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Box from '@mui/material/Box';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { FormattedMessage } from 'react-intl';
import IconButton from '@mui/material/IconButton';
import { useDisclosure } from '../../../hooks/useDisclosure';
import { useLocalization } from '../../../contexts/localizationContext';
import { useRef } from 'react';
import localesConfig from '../localesConfig';
export default function LocalePopover() {
  const localization = useLocalization();
  const anchorRef = useRef(null);
  const disclosure = useDisclosure();

  const activeLocale = localesConfig[localization.locale];

  const handleLocaleSelect = (locale) => {
    localization.setLocale(locale);
    disclosure.close();
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={disclosure.toggle}
        color="inherit"
      >
        <LanguageIcon />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={disclosure.isOpen}
        onClose={disclosure.close}
      >
        {Object.values(localesConfig).map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === activeLocale.value}
            onClick={handleLocaleSelect.bind(this, option.value)}
            sx={{ py: 1, px: 2.5 }}
          >
            <ListItemIcon>
              <Box component="img" alt={option.defaultLabel} src={option.icon} />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ variant: 'body2' }}>
              <FormattedMessage id={option.labelLocalId} defaultMessage={option.defaultLabel} />
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}